input {
  border: none;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  color: var(--lab-ds-semantic-color-fg-default);
  width: 100%;
}

.v4-input {
  display: flex;
  flex-direction: column;
  gap: var(--lab-ds-semantic-selectable-space-gap-s);
  color: var(--lab-ds-semantic-color-fg-default);
}
.v4-input .title-text {
  text-align: left;
  font: var(--lab-ds-semantic-typography-heading-h7);
}

.v4-input .input-helper {
  display: flex;
  flex-direction: column;
  gap: var(--lab-ds-semantic-selectable-space-gap-s);
}

.v4-input .helper-text {
  display: flex;
  align-items: center;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  font: var(--lab-ds-semantic-typography-body-none-decoration-p3-regular);
}

.input-field {
  width: 100%;
  min-width: 30%;
}

.chips {
  display: flex;
  width: 100%;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
}

.chip {
  width: 100%;
}

.chip-group {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
  max-width: 70%;
  overflow-x: auto;
  overflow-y: hidden;
}

.chip-group::-webkit-scrollbar {
  display: none;
}

.input-icon {
  display: flex;
  align-items: center;

  border-style: solid;
  border-radius: var(--lab-ds-semantic-selectable-border-radius-xs);
  border-width: var(--lab-ds-semantic-selectable-border-width-m);
  border-color: var(--lab-ds-semantic-selectable-color-border-default);
  background-color: var(--lab-ds-semantic-selectable-color-bg-default);

  padding-top: var(--lab-ds-semantic-selectable-space-padding-sm);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-sm);
  padding-left: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-right: var(--lab-ds-semantic-selectable-space-padding-m);
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
}

.input-icon .input-field {
  color: var(--lab-ds-semantic-color-fg-enabled);
  font: var(--lab-ds-semantic-typography-body-none-decoration-p2-regular);
}

.input-icon .icon.right {
  display: none;
}

.input-icon:focus-within {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.input-icon:hover {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-s);
  border-color: var(--lab-ds-semantic-selectable-color-primary-hover);
}

.input-icon:active {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.icon {
  display: flex;
}

.v4-input.error .input-icon {
  border-color: var(--lab-ds-semantic-selectable-color-border-dark-error);
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.error .input-icon .icon.right {
  display: flex;
}

.v4-input.error .input-field {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-error);
}

.v4-input.error .icon {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-error);
}

.v4-input.error .input-helper {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-error);
}

.v4-input.success .input-icon {
  border-color: var(--lab-ds-semantic-selectable-color-border-dark-success);
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
}

.v4-input.success .input-icon .icon.right {
  display: flex;
}

.v4-input.success .input-field {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
}

.v4-input.success .icon {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
}

.v4-input.success .input-helper {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
}

.v4-input.disabled .input-icon {
  background-color: var(--lab-ds-semantic-selectable-color-bg-disabled);
  border-color: var(--lab-ds-semantic-selectable-color-border-disabled);
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
  box-shadow: none;
}

.v4-input.disabled .title-text {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .input-field {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .icon {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .input-helper {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .chip-group {
  display: none;
}
